/* =========================================================
   BEDZ — SHOP PAY INSTALLMENT LOGO CLICK
   ========================================================= */

(function () {
  function installBedzShopPayClick() {
    const terms = document.querySelector('shopify-payment-terms');
    if (!terms) return;

    const root = terms.shadowRoot;
    if (!root) return;

    if (root.querySelector('[data-bedz-shop-pay-installed]')) return;

    const infoButton = root.querySelector('button') || root.querySelector('[role="button"]');
    if (!infoButton) return;

    const candidates = Array.from(root.querySelectorAll('span, a, div, svg'));
    const shopElement = candidates.find(function (el) {
      if (el === infoButton || infoButton.contains(el)) return false;

      const text = (el.textContent || '').trim().toLowerCase();
      const aria = (el.getAttribute('aria-label') || '').trim().toLowerCase();

      return text === 'shop' || text === 'shop pay' || aria.includes('shop pay');
    });

    if (!shopElement) return;

    shopElement.setAttribute('data-bedz-shop-pay-installed', 'true');
    shopElement.style.cursor = 'pointer';

    shopElement.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      infoButton.click();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    installBedzShopPayClick();

    let attempts = 0;
    const timer = setInterval(function () {
      attempts += 1;
      installBedzShopPayClick();
      if (attempts >= 20) clearInterval(timer);
    }, 250);
  });
})();

/* =========================================================
   BEDZ — GLOBAL NAVIGATION DRAWER
   One controller, no delayed DOM patching.
   ========================================================= */

(function () {
  if (window.__bedzDrawerControllerInstalled) return;
  window.__bedzDrawerControllerInstalled = true;

  function getDrawer() {
    return document.querySelector('[data-bedz-nav-drawer]');
  }

  function getOpenButtons() {
    return document.querySelectorAll('[data-bedz-menu-open]');
  }

  function setOpenButtonsState(isOpen) {
    getOpenButtons().forEach(function (button) {
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      button.classList.toggle('is-open', isOpen);
    });
  }

  function resetGroups(drawer) {
    if (!drawer) return;

    drawer.querySelectorAll('.bedz-nav-drawer__group.is-open').forEach(function (group) {
      group.classList.remove('is-open');
    });

    drawer.querySelectorAll('[data-bedz-drawer-toggle]').forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      const group = toggle.closest('.bedz-nav-drawer__group');
      const link = group && group.querySelector('.bedz-nav-drawer__parent-link');
      const name = link ? link.textContent.trim() : 'category';
      toggle.setAttribute('aria-label', 'Open ' + name + ' menu');
    });
  }

  function openDrawer(event) {
    if (event) event.preventDefault();

    const drawer = getDrawer();
    if (!drawer) return;

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bedz-nav-drawer-open');
    setOpenButtonsState(true);
  }

  function closeDrawer(event, options) {
    if (event) event.preventDefault();

    const drawer = getDrawer();

    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');

      if (!options || options.resetGroups !== false) {
        resetGroups(drawer);
      }
    }

    document.body.classList.remove('bedz-nav-drawer-open');
    setOpenButtonsState(false);
  }

  /*
   * The main Capital header hamburger still carries the theme's old
   * data-navigation-toggle/data-open hooks. On the homepage that old
   * theme controller competes with the BEDZ drawer on the first tap.
   * Intercept only that legacy+BEDZ button during capture and let the
   * BEDZ controller own the interaction completely.
   */
  document.addEventListener('click', function (event) {
    const legacyBedzButton = event.target.closest('[data-bedz-menu-open][data-navigation-toggle]');
    if (!legacyBedzButton) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    openDrawer();
  }, true);

  document.addEventListener('click', function (event) {
    const openButton = event.target.closest('[data-bedz-menu-open]');
    if (openButton) {
      openDrawer(event);
      return;
    }

    const drawer = getDrawer();
    if (!drawer) return;

    const closeButton = event.target.closest('[data-bedz-menu-close]');
    if (closeButton && drawer.contains(closeButton)) {
      closeDrawer(event);
      return;
    }

    const toggle = event.target.closest('[data-bedz-drawer-toggle]');
    if (toggle && drawer.contains(toggle)) {
      event.preventDefault();
      event.stopPropagation();

      const group = toggle.closest('.bedz-nav-drawer__group');
      if (!group) return;

      const isOpen = group.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      const link = group.querySelector('.bedz-nav-drawer__parent-link');
      const name = link ? link.textContent.trim() : 'category';
      toggle.setAttribute('aria-label', (isOpen ? 'Close ' : 'Open ') + name + ' menu');
      return;
    }

    const drawerLink = event.target.closest('a');
    if (drawerLink && drawer.contains(drawerLink)) {
      closeDrawer(null, { resetGroups: true });
    }
  });

  document.addEventListener('keydown', function (event) {
    const drawer = getDrawer();
    if (event.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  function resetDrawerCompletely() {
    closeDrawer(null, { resetGroups: true });
  }

  window.addEventListener('pageshow', resetDrawerCompletely);
  window.addEventListener('popstate', resetDrawerCompletely);
  document.addEventListener('shopify:section:load', resetDrawerCompletely);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resetDrawerCompletely, { once: true });
  } else {
    resetDrawerCompletely();
  }
})();

/* =========================================================
   BEDZ — HOMEPAGE SEARCH HANDOFF
   ========================================================= */

(function () {
  function initBedzHomepageSearchHandoff() {
    const heroSearch = document.querySelector('.bedz-search-hero__form');
    const stickySearch = document.querySelector('[data-bedz-sticky-search]');

    if (!heroSearch || !stickySearch) return;

    function updateStickySearch() {
      const heroRect = heroSearch.getBoundingClientRect();
      const shouldShow = heroRect.bottom <= 0;

      stickySearch.classList.toggle('is-visible', shouldShow);
      stickySearch.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    let ticking = false;

    function requestUpdate() {
      if (ticking) return;

      ticking = true;
      window.requestAnimationFrame(function () {
        updateStickySearch();
        ticking = false;
      });
    }

    updateStickySearch();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBedzHomepageSearchHandoff);
  } else {
    initBedzHomepageSearchHandoff();
  }
})();
